import { $Q } from '../utils/querySelector';

class SearchEmpty {
  /**
   * It initializes the empty search with total results and evaluates if total results equals zero
   * @param {Number} accResults : Accumulated results from products, pages and articles
   * @param {Number} collectionLength : Total results from collections
   */
  constructor(accResults, collectionLength) {
    this.totalResults = accResults + collectionLength || 0;
    this.removeLoader();

    if (this.totalResults) return;

    this.init();
  }

  /**
   * It gets emptySection and removes hidden class
   */
  init() {
    const emptySection = $Q('.search-results__results-content--empty');

    if (!emptySection) return;

    emptySection.classList.remove('hidden');
  }

  /**
   * It gets loader in DOM and add hidden class
   */
  removeLoader() {
    const loader = $Q('.search-results__results-container .search-loader');
    loader.classList.add('hidden');
  }
}

export { SearchEmpty };
